"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = {
    key: 0,
    class: "actions-buttons"
};
const vue_3 = require("vue");
const vue_i18n_1 = require("vue-i18n");
const quasar_1 = require("quasar");
const ui_kit_1 = require("@extracadabra/ui-kit");
const core_v2_1 = require("@extracadabra/core-v2");
const DocumentsList_component_vue_1 = require("@core/components/common/documents/DocumentsList.component.vue");
const useDocumentManager_1 = require("@etab/composables/useDocumentManager");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ServiceContract.page',
    setup(__props) {
        const DOCUMENT_TYPE = core_v2_1.DocumentType.ServiceContract;
        const APPLICATION = core_v2_1.Applications.Etablissement;
        const { t } = (0, vue_i18n_1.useI18n)();
        const $q = (0, quasar_1.useQuasar)();
        const { documentManagerRepository } = (0, vue_3.inject)("repositories");
        const { jobYears, currentYear, currentTotalPerPage, sortBy, allDocumentsFromCurrentYearSelected, filterOptions, selected, getjobYears, getDocuments, hasPagination, showCheckboxes, getAllDocumentsIds, downloadSelectedDocuments, isDownloadDocumentLoading, isDocumentsLoading, resetSelection, } = (0, useDocumentManager_1.useDocumentManager)(documentManagerRepository);
        const paginatedDocumentByYear = (0, vue_3.ref)({});
        const selectedCandidatesFilters = (0, vue_3.ref)([]);
        const selectedQualificationsFilters = (0, vue_3.ref)([]);
        const jobYearsSorted = (0, vue_3.computed)(() => {
            return sortBy.value === core_v2_1.SortBy.Descendant ? jobYears.value.slice().reverse() : jobYears.value;
        });
        const sortOptions = (0, vue_3.computed)(() => [
            { label: t("CORE.DOCUMENTS.@CONTRACT_SORT_DESC"), value: core_v2_1.SortBy.Descendant },
            { label: t("CORE.DOCUMENTS.@CONTRACT_SORT_ASC"), value: core_v2_1.SortBy.Ascendant },
        ]);
        const pageItems = (0, vue_3.computed)(() => {
            const year = currentYear.value;
            let documents = [];
            if (year) {
                documents = currentYearPageDocuments(year);
            }
            return documents;
        });
        const currentYearPageDocuments = (year) => {
            var _a, _b;
            const page = ((_a = paginatedDocumentByYear.value[year]) === null || _a === void 0 ? void 0 : _a.page) || 1;
            return (_b = paginatedDocumentByYear.value[year]) === null || _b === void 0 ? void 0 : _b.data[page];
        };
        const onAccordionClick = async (year, sort, userIds, qualificationIds) => {
            resetSelection();
            if (currentYear.value === year) {
                // reset accordion state
                currentYear.value = null;
            }
            else {
                currentYear.value = year;
                if (!paginatedDocumentByYear.value[year]) {
                    await getDocumentsHandler(currentYear.value, 1, sort);
                }
            }
        };
        const onSortSelect = (sort) => {
            sortBy.value = sort;
            currentYear.value = null;
            paginatedDocumentByYear.value = {};
            resetSelection();
        };
        const selectFilters = (ids) => {
            selectedCandidatesFilters.value = [];
            selectedQualificationsFilters.value = [];
            for (const id of ids) {
                const hasTypeOfUserId = !!(0, core_v2_1.getUserIdType)(id.toString());
                if (hasTypeOfUserId) {
                    selectedCandidatesFilters.value = [...selectedCandidatesFilters.value, id];
                }
                else {
                    selectedQualificationsFilters.value = [...selectedQualificationsFilters.value, id];
                }
            }
            currentYear.value = null;
            paginatedDocumentByYear.value = {};
            resetSelection();
        };
        const onPageChange = async (newPage) => {
            resetSelection();
            paginatedDocumentByYear.value[currentYear.value].page = newPage;
            await getDocumentsHandler(currentYear.value, newPage, sortBy.value);
        };
        const onDocumentSelect = (isChecked, id) => {
            if (selected.value.includes(id)) {
                selected.value = selected.value.filter((value) => value !== id);
            }
            else {
                selected.value = [...selected.value, id];
            }
            const areItemsSelected = selected.value.length === currentTotalPerPage.value;
            allDocumentsFromCurrentYearSelected.value = areItemsSelected;
        };
        const onDownloadDocumentsClick = async (ids) => {
            isDownloadDocumentLoading.value = true;
            await downloadSelectedDocuments(APPLICATION, DOCUMENT_TYPE, ids);
            isDownloadDocumentLoading.value = false;
        };
        const onSelectAllClick = async (year) => {
            const ids = await getAllDocumentsIds(year, DOCUMENT_TYPE);
            selected.value = [...ids];
            allDocumentsFromCurrentYearSelected.value = true;
        };
        const selectAllDocumentsFromPage = (value, ids = []) => {
            const areAllSelected = ids.every((id) => selected.value.includes(id));
            if (areAllSelected) {
                selected.value = [];
                allDocumentsFromCurrentYearSelected.value = false;
            }
            else {
                selected.value = [...ids];
                allDocumentsFromCurrentYearSelected.value = true;
            }
        };
        const getDocumentsHandler = async (year, page, sort) => {
            const { total, data, pageSize } = await getDocuments(APPLICATION, DOCUMENT_TYPE, {
                page,
                year,
                sort,
                qualificationIds: selectedQualificationsFilters.value,
                userIds: selectedCandidatesFilters.value,
            });
            isDocumentsLoading.value = true;
            if (!paginatedDocumentByYear.value[year]) {
                paginatedDocumentByYear.value[year] = {
                    page: 1,
                    data: { [page]: data },
                    total,
                    pageSize,
                };
            }
            else {
                paginatedDocumentByYear.value[year].total = total;
                paginatedDocumentByYear.value[year].data[page] = data;
            }
            isDocumentsLoading.value = false;
        };
        (0, vue_3.onMounted)(async () => {
            var _a;
            jobYears.value = await getjobYears(DOCUMENT_TYPE);
            filterOptions.value = await new core_v2_1.GetDocumentFilters(documentManagerRepository).execute(APPLICATION, DOCUMENT_TYPE);
            currentYear.value = jobYearsSorted.value[0];
            if (!paginatedDocumentByYear.value[currentYear.value]) {
                await getDocumentsHandler(currentYear.value, ((_a = paginatedDocumentByYear.value[currentYear.value]) === null || _a === void 0 ? void 0 : _a.page) || 1, sortBy.value);
            }
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e;
            const _component_QExpansionItem = (0, vue_2.resolveComponent)("QExpansionItem");
            const _component_QIcon = (0, vue_2.resolveComponent)("QIcon");
            const _component_QBtn = (0, vue_2.resolveComponent)("QBtn");
            const _component_QSpace = (0, vue_2.resolveComponent)("QSpace");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createVNode)(_component_QExpansionItem, {
                    dense: "",
                    "header-class": "text-center text-bold",
                    label: (0, vue_2.unref)(t)('ETAB.PAGES.DOCUMENT_MANAGER.SUM_UP.SERVICE_CONTRACT.@SUM_UP_TITLE'),
                    "label-lines": 0,
                    class: "bg-secondary-50 q-my-md shadow-md"
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", {
                            class: "content",
                            innerHTML: (0, vue_2.unref)(t)('ETAB.PAGES.DOCUMENT_MANAGER.SUM_UP.SERVICE_CONTRACT.@SUM_UP_DESCRIPTION')
                        }, null, 8, _hoisted_1)
                    ]),
                    _: 1
                }, 8, ["label"]),
                ((0, vue_2.unref)(jobYears).length)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("section", _hoisted_2, [
                        ((0, vue_2.unref)(selected).length > 1)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_QBtn, {
                                key: 0,
                                loading: (0, vue_2.unref)(isDownloadDocumentLoading),
                                dense: "",
                                "no-caps": "",
                                rounded: "",
                                outline: "",
                                color: "secondary",
                                class: "q-px-md bg-white",
                                onClick: _cache[0] || (_cache[0] = ($event) => (onDownloadDocumentsClick((0, vue_2.unref)(selected))))
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(t)("CORE.DOCUMENTS.@DOWNLOAD_COUNT", (0, vue_2.unref)(selected).length)) + " ", 1),
                                    (0, vue_2.createVNode)(_component_QIcon, {
                                        size: "xs",
                                        name: "fad fa-download",
                                        color: "secondary",
                                        class: "q-ml-sm"
                                    })
                                ]),
                                _: 1
                            }, 8, ["loading"]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createVNode)(_component_QSpace),
                        (0, vue_2.createVNode)((0, vue_2.unref)(ui_kit_1.Popover), {
                            class: "q-mb-sm",
                            label: (0, vue_2.unref)(t)('ETAB.PAGES.DOCUMENT_MANAGER.@FILTERS'),
                            items: (0, vue_2.unref)(filterOptions),
                            icon: "filters",
                            multiple: "",
                            "use-input": "",
                            grouped: "",
                            direction: "row",
                            "text-color": "secondary",
                            "border-color": "secondary",
                            onAction: selectFilters
                        }, null, 8, ["label", "items"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(ui_kit_1.Popover), {
                            class: "q-mb-sm",
                            value: (0, vue_2.unref)(sortBy),
                            label: (0, vue_2.unref)(t)('ETAB.PAGES.DOCUMENT_MANAGER.@SORT'),
                            items: sortOptions.value,
                            icon: "sort",
                            direction: "column",
                            multiple: false,
                            grouped: false,
                            "text-color": "secondary",
                            "border-color": "secondary",
                            onAction: onSortSelect
                        }, null, 8, ["value", "label", "items"])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createVNode)(DocumentsList_component_vue_1.default, {
                    documents: paginatedDocumentByYear.value,
                    "onUpdate:documents": _cache[1] || (_cache[1] = ($event) => ((paginatedDocumentByYear).value = $event)),
                    app: (0, vue_2.unref)(APPLICATION),
                    "page-items": pageItems.value,
                    years: jobYearsSorted.value,
                    "current-year": (0, vue_2.unref)(currentYear),
                    "opened-accordion": (0, vue_2.unref)(currentYear),
                    pagination: (0, vue_2.unref)(hasPagination)((_a = paginatedDocumentByYear.value[(0, vue_2.unref)(currentYear)]) === null || _a === void 0 ? void 0 : _a.total, (_b = paginatedDocumentByYear.value[(0, vue_2.unref)(currentYear)]) === null || _b === void 0 ? void 0 : _b.pageSize),
                    selected: (0, vue_2.unref)(selected),
                    "has-more-than-one-page": (0, vue_2.unref)(hasPagination)((_c = paginatedDocumentByYear.value[(0, vue_2.unref)(currentYear)]) === null || _c === void 0 ? void 0 : _c.total, (_d = paginatedDocumentByYear.value[(0, vue_2.unref)(currentYear)]) === null || _d === void 0 ? void 0 : _d.pageSize),
                    "are-all-current-year-page-items-selected": (0, vue_2.unref)(allDocumentsFromCurrentYearSelected),
                    "page-size": (_e = paginatedDocumentByYear.value[(0, vue_2.unref)(currentYear)]) === null || _e === void 0 ? void 0 : _e.pageSize,
                    "show-checkboxes": (0, vue_2.unref)(showCheckboxes)((0, vue_2.unref)($q).screen.gt.sm),
                    onSelectWholeYearItems: onSelectAllClick,
                    onSelectWholePageItems: selectAllDocumentsFromPage,
                    onToggleDocument: onDocumentSelect,
                    onToggleAccordion: _cache[2] || (_cache[2] = (year) => onAccordionClick(year, (0, vue_2.unref)(sortBy), selectedCandidatesFilters.value, selectedQualificationsFilters.value)),
                    onResetSelectedItems: onPageChange
                }, null, 8, ["documents", "app", "page-items", "years", "current-year", "opened-accordion", "pagination", "selected", "has-more-than-one-page", "are-all-current-year-page-items-selected", "page-size", "show-checkboxes"])
            ], 64));
        };
    }
});
